import React, { useState } from 'react';
import SideBar from '../../Components/Sidebar';
import NavBar from '../../Components/navbar';
import BasicTable from '../../Components/BasicTable';
import Search from '../../Components/Search';
import Title from '../../Components/Title';
import DropDown from '../../Components/DropDown';
import style from './style';
import useDepartments from './Hooks/useDepartment';
import useComponent from './Hooks/useComponent';
import useSearch from './Hooks/useSearch';
import useTranslation from '../../Hooks/useTranslation';
import { Drawer } from 'Components/Drawer/Drawer/Drawer';
import SideBarContainer from 'Containers/SideBarContainer';

const { containerDepartment, searchContainer, findContainer } = style;

export default function Departments() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const { departments, setDepartments } = useDepartments(setIsLoading);
  const { thereIsComponent } = useComponent({ departments, setDepartments });
  const { setSearch, setStatus, departmentsFilters } = useSearch({
    departments,
  });
  const methods = [setStatus];
  const titles = [t('Department.Status')];
  const options = [['Activo', 'Inactivo']];

  return (
    <SideBarContainer navBar={true}>
      <div className="flex">
        <div style={containerDepartment} className="col">
          <Title title={t('Department.Title')} subtitle="" />
          <div style={searchContainer}>
            <div style={{ width: '40%' }}>
              <Search placeholder={t('Department.Title')} setData={setSearch} />
            </div>
            <div style={findContainer}>
              {titles.map((title, index) => (
                <DropDown key={title} title={title} options={options[index]} setData={methods[index]} />
              ))}
            </div>
          </div>

          <BasicTable
            headers={[t('Department.Name'), t('Department.Status')]}
            information={departmentsFilters}
            thereIsComponent={thereIsComponent}
            limit={2}
            isLoading={isLoading}
          />
        </div>
      </div>
    </SideBarContainer>
  );
}
